import { Component, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import {
  breadcrumb,
  link,
  stat,
} from 'src/app/admin/layout/header/header.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DataService } from 'src/app/services/data.service';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { Message } from 'primeng/api';
import {
  ConfirmationService,
  MessageService,
  ConfirmEventType,
} from 'primeng/api';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';


import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class LocationsComponent {
  skelition = true;

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;
  messages: Message[] = [];

  header = this.translate('the cities');
  links: link[] = [
    { 
      name: 'رجوع',
      icon: 'pi pi-angle-right',
      link: '/admin/organization-units',
    },
    {
      name: 'الأنواع',
      icon: 'pi pi-list',
      link: '/admin/organization-units/types',
      visible:this.permissionService.hasPermission('OU_TYPE','r')
    },
    {
      name: 'التصنيفات',
      icon: 'pi pi-sitemap',
      link: '/admin/organization-units/categories',
      visible:this.permissionService.hasPermission('OU_CATEGORY','r')
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Entities'), link: '/admin/organization-units' },
    { name: this.translate('the cities'), link: '/admin/organization-units/locations' },
  ];
  stats: stat[] = [];
  catdata: any[] = [];

  data: any[] = [];
  iconOptions: SelectItem[] = [];
  questions: QuestionBase<string>[] = [];
  translator:TranslatorPipe = new TranslatorPipe()

  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService:PermissionHandlerService
  ) {}

  ngOnInit() {
    this.getLocation();
    this.makequestion();
  }
  getLocation = async () => {
    try {
      let res = await this.dataService.getData('location');
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.catdata = [];
      this.catdata = res.data;
      this.catdata.forEach((item: any) => {
        this.data.push({
          '#': { n: item._id, i: 'pi pi-angle-left' },
          'اسم المدينة': { n: item.name, i: 'pi pi-map-marker' },
          'الحالة': {
            n: item.active,
            i: item.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
          },
          Action: [
            {
              n: 'Delete',
              i: 'pi pi-times',
              s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ],
        });
      });

      this.updateLocationCounts();
      this.skelition = false;
    } catch (error) {
      console.log(error);
    }
  };

  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  makequestion() {
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: 'اسم المدينة',
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'active',
        label: 'الحالة',
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
        value:true,
        visibility:"false"
      }),
    ];
  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;
      let res = await this.dataService.postData('location', data);
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.DynamicFormComponent.resetForm();
      this.catdata.push(res.data);
      this.data.unshift({
        '#': { n: res.data._id, i: 'pi pi-angle-left' },
        'اسم المدينة': { n: data.name, i: 'pi pi-map-marker' },
        'الحالة': {
          n: data.active,
          i: data.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
        },
        Action: [
          {
            n: 'Delete',
            i: 'pi pi-times',
            s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
          },
          {
            n: 'Update',
            i: 'pi pi-file-edit',
            s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          },
        ],
      });
      this.updateLocationCounts();
    } catch (error) {
      console.log(error);
    }
  };

  UpdateData = async ($event: any) => {
    try {
      let data: any = $event;
      data._id = this.updateData._id;
      let res = await this.dataService.postData(
        'location',
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      // updating in table
      const myObject = this.data.find((item) => item['#'].n === data._id);
      myObject['اسم المدينة'].n = data.name;
      myObject['الحالة'].n = data.active;
      myObject['الحالة'].i = data.active
        ? 'pi pi-check-circle'
        : 'pi pi-check-circle';

      this.data.map((e, i) => {
        if (e['#'].n === data._id) {
          this.data[i] = myObject;
          return;
        }
      });

      console.log(this.catdata);
      this.catdata.map((e, i) => {
        if (e._id === data._id) {
          this.catdata[i] = data;
          return;
        }
      });

      this.updateLocationCounts();
    } catch (error) {
      console.log(error);
    }
  };

  actionCall($event: any) {
    console.log($event);
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteCatagory($event.id),
        });
        break;
      case 'Update':
        this.updateData = this.catdata.find((item) => item._id == $event.id);
        console.log(this.updateData?.active);
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: 'اسم المدينة',
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-12',
          }),
          new DropdownQuestion({
            key: 'active',
            label: 'الحالة',
            required: true,
            value: this.updateData?.active,
            options: [
              { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
              { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
            ],
            order: 4,
            className: 'col-12',
          }),
        ];
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  deleteCatagory = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`location/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.data = this.data.filter((item) => item['#'].n !== id);
      this.catdata = this.catdata.filter((item) => item._id !== id);
      this.updateLocationCounts();
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel:'نعم',
      rejectLabel:'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  private updateLocationCounts(): void {
    let activeLocations = this.catdata.filter(
      (item) => item.active === true
    ).length;
    let inactiveLocations = this.catdata.length - activeLocations;
    this.stats = [
      {
        name: this.translate('active'),
        number: activeLocations,
        icon: 'pi pi-check-circle',
      },
      {
        name: this.translate('Inactive'),
        number: inactiveLocations,
        icon: 'pi pi-times-circle',
      },
    ];
  }
}
